function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmallCheckMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "Layer_1",
  width: 10.443,
  height: 7.801,
  x: 0,
  y: 0,
  viewBox: "0 0 10.443 7.801"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.057 7.8 0 3.745 1.414 2.33l2.643 2.643L9.029 0l1.414 1.414z",
  style: {
    fill: "#080808"
  }
}));
export default SvgSmallCheckMark;